import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-switch',
  templateUrl: './switch.component.html',
  styleUrls: ['./switch.component.scss']
})
export class SwitchComponent implements OnInit {
  toggle_status: boolean = false
  @Input('labelAfter') labelAfter: boolean = false;
  @Input('label') label: string;
  @Input('disabled') disabled: boolean = false;
  /**
   * @description
   * default value to get unique lable for value
   * @requires to provide a unique different value from the parent
  */
  @Input('for') for: number | string = Date.now();

  @Input('checked') set checked(value: boolean) {
    this.toggle_status = value;
  }

  @Output() onToggle: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor() { }

  ngOnInit(): void { }

  onChange() {
    this.onToggle.emit(this.toggle_status);
  }
}
